import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class StepperServiceService {
  public dataChange = new Subject<any>();

  setData(data: any) {        
    this.dataChange.next(data);
  }

  constructor() { }
}
